<template>
  <v-list-item @click="!noclick ? select() : null"
    :class="[appointment.new ? 'newcolor' : '', appointment.changed ? 'changecolor' : '', appointment.deleted ? 'errorcolor' : '']"
    class="appointment-li">
    <v-list-item-icon class="my-auto mr-5 d-flex align-center">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" :color="progressColor(appointment)"
            v-text="'$appointment'" />
        </template>
        <span
          v-text="(inProgress(appointment) === 0) ? $t('servicesystem.common_objects.appointment.in_progress') : fromNow(appointment.StartTime)"></span>
      </v-tooltip>

    </v-list-item-icon>
    <v-list-item-content>
      <v-container fluid class="pa-0">
        <v-row no-gutters>
          <v-col cols="7">
            <v-container class="pa-0" fluid>
              <v-row no-gutters>
                <v-list-item-title
                  v-text="showSubject ? appointment.Subject : ($t('servicesystem.common_objects.appointment.appointment') + ' ' + appointment.Id)" />
              </v-row>
              <v-row no-gutters>
                <v-list-item-subtitle class="d-flex mr-2">
                  <div class="nowrapheader mr-1" v-text="PrimaryParticipantText" />
                  <div class="primary--text" v-text="AdditionalParticipantText" />
                </v-list-item-subtitle>
              </v-row>
            </v-container>
          </v-col>
          <v-col cols="5">
            <v-container v-if="multiday" class="pa-0" fluid>
              <v-row no-gutters>
                <v-col cols="4">
                  <v-list-item-title class="primary--text">{{ i18nFormatTime(appointment.StartTime) }}</v-list-item-title>
                </v-col>
                <v-col cols="8">
                  <v-list-item-title class="primary--text">{{ i18nFormatDate(appointment.AppointmentDate)
                  }}</v-list-item-title>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="4">
                  <v-list-item-subtitle class="tertiary--text">{{ i18nFormatTime(appointment.EndTime)
                  }}</v-list-item-subtitle>
                </v-col>
                <v-col cols="8">
                  <v-list-item-title class="tertiary--text">{{ i18nFormatDate(appointment.EndTime) }}</v-list-item-title>
                </v-col>
              </v-row>
            </v-container>
            <v-container v-else class="pa-0" fluid>
              <v-row no-gutters>
                <v-col cols="auto">
                  <v-list-item-title class="primary--text">{{ i18nFormatTime(appointment.StartTime) }}</v-list-item-title>
                </v-col>
                <v-col cols="auto">
                  <v-card color="transparent" flat width="20px" class="text-center">
                    {{ $t('servicesystem.common_objects.commonterms.to') }}
                  </v-card>
                </v-col>
                <v-col cols="auto">
                  <v-list-item-subtitle class="tertiary--text">{{ i18nFormatTime(appointment.EndTime)
                  }}</v-list-item-subtitle>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-list-item-title class="primary--text">{{ i18nFormatDate(appointment.AppointmentDate)
                  }}</v-list-item-title>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </v-list-item-content>
    <v-badge v-if="appointment.new" :content="$t('servicesystem.common_objects.commonterms.new')" left color="green"
      :offset-x="0" :offset-y="10">
    </v-badge>
    <v-badge v-if="appointment.changed" :content="$t('servicesystem.common_objects.commonterms.changed')" left
      color="orange" :offset-x="0" :offset-y="10">
    </v-badge>
    <v-badge v-if="appointment.deleted" :content="$t('servicesystem.common_objects.commonterms.deleted')" left color="red"
      :offset-x="0" :offset-y="10">
    </v-badge>
    <v-list-item-action class="ma-0">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-if="!appointment.deleted" @click.stop="removeable ? remove() : null" v-bind="attrs" v-on="on"
            icon>
            <v-icon size="22" :color="removeable ? '' : 'disabled'"
              v-text="removeable ? 'mdi-delete' : 'mdi-delete-off'" />
          </v-btn>
        </template>
        <span
          v-text="removeable ? $t('servicesystem.common_objects.commonterms.delete') : $t('servicesystem.common_objects.commonterms.not_deleteable')" />
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
</template>


<script>
export default {
  name: "AppointmentListItem",
  props: {
    appointment: Object,
    noclick: Boolean,
    noremove: Boolean,
    previewMode: Boolean,
    showSubject: Boolean,
  },
  components: {},

  data() {
    return {
      selectedItemId: null,
    };
  },

  mounted() {

  },

  methods: {
    select() {
      this.$emit("Select", this.appointment);
    },

    async remove() {
      var result = await this.$store.dispatch("ConfirmDialog/Show");
      if (result) {
        this.$emit("Remove", this.appointment.Id);
      }
    },
  },

  computed: {
    PrimaryParticipantText() {
      if (!this.appointment || !this.appointment.Participants || this.appointment.Participants.length < 1) {
        return "0 " + this.$t("servicesystem.common_objects.appointment.participants");
      } else {
        var PrimaryParticipant = this.appointment.Participants[0];
        return PrimaryParticipant.User.Name;
      }
    },

    AdditionalParticipantText() {
      if (!this.appointment || !this.appointment.Participants || this.appointment.Participants.length < 2) {
        return "";
      } else {
        const addcount = this.appointment.Participants.length - 1;
        return (
          " +" +
          addcount /*+(addcount > 1 ? this.$t("servicesystem.common_objects.appointment.participants") : this.$t("servicesystem.common_objects.appointment.participant"))*/
        );
      }
    },

    removeable() {
      return !this.noremove;
    },

    multiday() {
      return this.comparetime(this.appointment.StartTime, this.appointment.EndTime);
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>